import React from 'react';
import type { EntryPointProps } from 'react-relay';
import { metrics } from '@atlassian/browser-metrics';
import LoginRedirect from '@atlassian/jira-common-navigation/src/login-redirect/index.tsx';
import { NotificationsPersonalSettings } from '@atlassian/jira-personal-settings-notifications/src/index.tsx';
import SubmitApdex from '@atlassian/jira-providers-spa-apdex-analytics/src/submit-apdex-mark/index.tsx';
import type { BM3Metric } from '@atlassian/jira-providers-spa-apdex-analytics/src/submit-apdex-mark/types.tsx';
import type { ui_NotificationsPageAndProjectQuery } from '@atlassian/jira-relay/src/__generated__/ui_NotificationsPageAndProjectQuery.graphql';
import type { AccountId } from '@atlassian/jira-shared-types/src/general.tsx';
import { SubProductUpdater } from '@atlassian/jira-spa-apps-common/src/analytics-sub-product/sub-product-updater/index.tsx';
import { MarkProductStart } from '@atlassian/jira-spa-performance-breakdown/src/utils/mark-product-start/index.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { withRouter } from '@atlassian/react-resource-router';
import { NotificationsPageTitle } from './ui/index.tsx';

// Queries your component uses
type Queries = { pageAndProject: ui_NotificationsPageAndProjectQuery };

// Props from your EntryPoints definition you wish to pass to your component
type ExtraProps = {
	accountId: AccountId | null;
};

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const notificationsPersonalSettingsPageLoad = metrics.pageLoad({
	key: 'personal-settings-notifications',
	ssr: {
		doneAsFmp: true,
	},
}) as unknown as BM3Metric;

const NotificationsPersonalSettingsShell = ({
	extraProps,
	queries,
}: EntryPointProps<Queries, {}, {}, ExtraProps>) => (
	<UFOSegment name="personal-settings-notifications">
		<MarkProductStart />
		{extraProps.accountId ? (
			queries?.pageAndProject && (
				<>
					<NotificationsPersonalSettings queryReference={queries?.pageAndProject} />
					<SubmitApdex
						appName="personal-settings-notifications"
						isExpectedToHaveSsr
						metric={notificationsPersonalSettingsPageLoad}
					/>
					<SubProductUpdater subProduct="platform" />
					<NotificationsPageTitle />
				</>
			)
		) : (
			<LoginRedirect />
		)}
	</UFOSegment>
);

export default withRouter(NotificationsPersonalSettingsShell);
